import { render, staticRenderFns } from "./BlogBanner.vue?vue&type=template&id=1fa29f38&scoped=true&"
import script from "./BlogBanner.vue?vue&type=script&lang=js&"
export * from "./BlogBanner.vue?vue&type=script&lang=js&"
import style0 from "./BlogBanner.vue?vue&type=style&index=0&id=1fa29f38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa29f38",
  null
  
)

export default component.exports